module.exports = {
  "version": "0.28.0"
};


//////////////////
// WEBPACK FOOTER
// /home/runner/work/RS-rydges2018-docker/RS-rydges2018-docker/wp-content/themes/rydges/node_modules/axios/lib/env/data.js
// module id = 31
// module chunks = 0